import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Footer.scss";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer-inner">
                <div className="footer-brand">
                    <NavLink to="/" className="footer-logo" aria-label="KayKo Designs - Home">
                        <img src="/images/kkd_logo_light.svg" alt="" onError={(e) => { e.currentTarget.src = 'https://storage.googleapis.com/kayko_design_portfolio/kkd_logo_light.svg'; }} />
                    </NavLink>

                    <div className="footer-meta">
                        <small>© {year} KayKo Designs</small>
                    </div>
                </div>

                <div className="footer-actions contact-actions">
                    <a
                        href="https://www.linkedin.com/in/kayleighschlupp/"
                        className="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open LinkedIn (opens in a new tab)"
                    >
                        <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
                    </a>
                    <a
                        href="https://github.com/kkowatsch"
                        className="btn btn-icon"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Open GitHub (opens in a new tab)"
                    >
                        <FontAwesomeIcon icon={['fab', 'github']} />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;